import { render, staticRenderFns } from "./AdminGeneralHubV.vue?vue&type=template&id=f6355d1a"
import script from "./AdminGeneralHubV.vue?vue&type=script&lang=js"
export * from "./AdminGeneralHubV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports